/*
 * Cozyleigh search sheet (Oct 25 2026). Showcase opens and closes #search-modal; this fills it while someone types:
 * from two letters it asks Shopify's predictive search for sections/cl-search-suggest and shows that in place of the
 * starting points. Up and down arrows move between the field and the answers. Markup: snippets/cl-search-sheet.liquid.
 */
(function () {
  var sheet = document.getElementById('search-modal');
  if (!sheet || !sheet.classList.contains('cl-srch')) return;

  var input = sheet.querySelector('.cl-srch__input');
  var idle = sheet.querySelector('[data-cl-srch-idle]');
  var results = sheet.querySelector('[data-cl-srch-results]');
  var live = sheet.querySelector('[data-cl-srch-live]');
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var timer = null;
  var controller = null;
  var lastQuery = null;
  var cache = {};

  var body = sheet.querySelector('.cl-srch__body');

  function loading(on) {
    body.classList.toggle('is-loading', on);
    body.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function showIdle() {
    if (controller) controller.abort();
    loading(false);
    lastQuery = null;
    results.hidden = true;
    results.innerHTML = '';
    idle.hidden = false;
    live.textContent = '';
  }

  function paint(html) {
    loading(false);
    results.innerHTML = html;
    results.hidden = false;
    idle.hidden = true;
    var count = results.querySelector('[data-cl-srch-count]');
    live.textContent = count ? count.textContent : '';
  }

  function suggest(query) {
    if (query === lastQuery) return;
    lastQuery = query;
    if (cache[query]) {
      paint(cache[query]);
      return;
    }
    if (controller) controller.abort();
    controller = 'AbortController' in window ? new AbortController() : null;
    loading(true);
    var url = root + 'search/suggest?q=' + encodeURIComponent(query) +
      '&section_id=cl-search-suggest' +
      '&resources[type]=product,collection,page,article' +
      '&resources[limit]=8&resources[limit_scope]=each' +
      '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
    fetch(url, controller ? { signal: controller.signal } : {})
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var section = doc.querySelector('.shopify-section') || doc.body;
        cache[query] = section.innerHTML;
        if (lastQuery === query && input.value.trim() === query) paint(cache[query]);
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        // Suggestions failed to load: back to the starting points (never the last word's answers), and Enter still goes
        // to the full results page.
        if (lastQuery === query) showIdle();
      });
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    var query = input.value.trim();
    if (query.length < 2) {
      showIdle();
      return;
    }
    if (query !== lastQuery) loading(true);
    timer = setTimeout(function () { suggest(query); }, 150);
  });

  // Up and down move through the field and every link in the sheet that is showing (Baymard: keyboard support).
  sheet.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
    var scope = results.hidden ? idle : results;
    var stops = [input].concat(Array.prototype.slice.call(scope.querySelectorAll('a[href]')));
    var at = stops.indexOf(document.activeElement);
    if (at === -1) return;
    event.preventDefault();
    var next = at + (event.key === 'ArrowDown' ? 1 : -1);
    if (next < 0 || next >= stops.length) return;
    stops[next].focus();
  });

  // Open and closed. Showcase shows the sheet by adding .reveal and moves it off-screen when closed, so while closed it is
  // inert and hidden from screen readers. Opening is undone in the click's capture phase, before Showcase's own handler
  // focuses the field (iOS only opens the keyboard for a focus inside the tap). On close, focus goes back to the icon.
  var opener = null;

  function setOpen(open) {
    if (open) {
      sheet.inert = false;
      sheet.removeAttribute('inert');
      sheet.removeAttribute('aria-hidden');
      sheet.setAttribute('aria-modal', 'true');
    } else {
      sheet.inert = true;
      sheet.setAttribute('inert', '');
      sheet.setAttribute('aria-hidden', 'true');
      sheet.removeAttribute('aria-modal');
    }
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest && event.target.closest('[data-modal-toggle="#search-modal"]');
    if (!toggle || document.body.classList.contains('modal-active')) return;
    opener = toggle;
    setOpen(true);
    // Showcase only focuses the field on phones; focus it on computers too, and pick up a query left from last time.
    setTimeout(function () {
      if (document.activeElement !== input) input.focus({ preventScroll: true });
    }, 50);
    var query = input.value.trim();
    if (query.length >= 2) suggest(query);
  }, true);

  setOpen(sheet.classList.contains('reveal'));

  new MutationObserver(function () {
    var open = sheet.classList.contains('reveal');
    if (open) {
      setOpen(true);
      return;
    }
    if (sheet.inert) return;
    setOpen(false);
    // Back to the icon once Showcase has finished closing (it hides and shows the header bar while it does).
    var back = opener;
    opener = null;
    setTimeout(function () {
      var lost = !document.activeElement || document.activeElement === document.body || sheet.contains(document.activeElement);
      if (back && lost && document.contains(back)) back.focus({ preventScroll: true });
    }, 400);
  }).observe(sheet, { attributes: true, attributeFilter: ['class'] });

  // Tab stays inside the open sheet.
  sheet.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var stops = Array.prototype.filter.call(
      sheet.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"])'),
      function (el) { return el.offsetParent !== null || el === document.activeElement; }
    );
    if (!stops.length) return;
    var first = stops[0];
    var last = stops[stops.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
